export default {
  dashboard: "Dashboard",
  users: "Users",
  adminActivities: "Activities",
  adminStructures: "Structures",
  activities: "Activities",
  myHouses: "My Structures",
  bookings: "Bookings",
  partnersAndHosts: "Sellers & hosts",
  wallet: "Wallet",
  points: "Points",
  settings: "Settings",
  helpSupport: "Help & Support",
  devices: "Device management",
  devicesList: "Devices",
  devicesPresets: "Device presets",
  devicesCarousel: "Carousel",
  devicesStatistics: "Statistics",
  readers: "Readers",
  supportTickets: "User support",
  supportTicketsList: "Partner tickets",
  supportChats: "Customer chats",
  adminPayments: "Accounting",
  adminPaymentsEvents: "Economic events",
  adminPaymentsExternal: "External payments",
  adminPaymentsSettlements: "Settlements",
  adminNotifications: "Notifications",
  adminProtocols: "Protocols",
  adminAgentTranscripts: "Voice transcripts",
  adminNotificationsOpen_one: "{{count}} open notification",
  adminNotificationsOpen_other: "{{count}} open notifications",
  bookingsNew_one: "{{count}} new booking",
  bookingsNew_other: "{{count}} new bookings",
  completeProfile: "Complete your profile",
  completeProfileTitle: "Legal profile incomplete",
  completeProfileDescription:
    "Until your legal profile is complete, your activities cannot be shown to customers in the catalog.",
  completeProfileLink: "Complete profile →",
  logout: "Log out",
  impersonating: "Impersonating",
  stopImpersonating: "Stop impersonating",
  logoutWhileImpersonatingTitle: "You are impersonating {{name}}",
  logoutWhileImpersonatingMessage:
    "Do you want to stop impersonating or log out?",
  groups: {
    overview: "Overview",
    management: "Management",
    operations: "Operations",
    finance: "Finance",
    account: "Account",
  },
  theme: {
    switchToLight: "Switch to light theme",
    switchToDark: "Switch to dark theme",
  },
  search: "Search…",
  openMenu: "Open menu",
  closeMenu: "Close menu",
  breadcrumb: "Breadcrumb",
} as const;
